<template>
    <div>
        <CCard>
            <CCardBody>
                <v-toolbar flat color="white">
                    <v-toolbar-title>بارکدخوان</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="confirmDialog" max-width="400px">
                        <v-card>
                            <v-card-text class="pb-0">
                                <v-container class="pb-0">
                                    <h4>تغییر محل در انبار</h4>
                                    <v-divider/>
                                    <p>آیا از این کار اطمینان دارید؟</p>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <CButton color="danger" class="mb-2 ml-2 text-white"
                                         @click="confirmDialog = false">
                                    خیر
                                </CButton>
                                <CButton color="primary" class="mb-2 ml-2 text-white"
                                         @click="changeProductInventoryInfo">
                                    بلی
                                </CButton>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
                <CRow>
                    <CCol sm="3">
                        <CInput
                                label="بارکد"
                                v-model="barCodeText"
                                @keypress="isNumber($event)"
                                v-hotkey="keymap"
                                dir="ltr"
                        />
                    </CCol>
                    <CCol sm="3">
                        <CButton color="primary" class="text-white mt-7" @click="barCodeSearch">
                            جستجو
                        </CButton>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol md="12">
                        <CCollapse :show="collapseBraCodeInfo" :duration="400">
                            <CCard>
                                <CCardHeader>
                                    <strong> اطلاعات کالا </strong>
                                </CCardHeader>
                                <CCardBody>
                                    <CRow>
                                        <CCol sm="6">
                                            <label>بارکد: <b>{{productInfo.location.barcode}}</b></label>
                                        </CCol>
                                        <CCol sm="6">
                                            <label>نام کالا: <b>{{productInfo.product.name}}</b></label>
                                        </CCol>
                                        <CCol sm="6">
                                            <label>زیر محصول: <b>{{productInfo.product.tagsname}}</b></label>
                                        </CCol>
                                        <CCol sm="6">
                                            <label>مدل کالا: <b>{{productInfo.product.model}}</b></label>
                                        </CCol>
                                        <CCol sm="6">
                                            <label>شناسه زیرمحصول: <b>{{productInfo.product.product_option_id}}</b></label>
                                        </CCol>
                                        <CCol sm="6">
                                            <label>شناسه کالا در سایت:
                                                <b>{{productInfo.product.opencart_product_id}}</b></label>
                                        </CCol>
                                        <CCol sm="12">

                                          <CButton color="danger" class="text-white mb-2 ml-2" @click="removeBarcode()">
                                              حذف این بارکد
                                          </CButton>

                                          <CButton color="warning" class="text-white mb-2 ml-2" @click="replaceBarcode()">
                                            جایگزینی بارکد
                                          </CButton>

                                          <CButton color="info" class="text-white mb-2 ml-2" @click="enableEditBarcode()">
                                            ویرایش بارکد
                                          </CButton>

                                        </CCol>

                                        <CCol sm="12" v-if="editBarcode.enable">
                                          <CInput
                                              label="شناسه زیرمحصول جدید"
                                              v-model="editBarcode.product_option_id"
                                              class="editbox"
                                          />
                                        </CCol>

                                    </CRow>
                                </CCardBody>
                            </CCard>
                        </CCollapse>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol md="12">
                        <CCollapse :show="collapseBraCodeInfo" :duration="400">
                            <CCard>
                                <CCardHeader>
                                    <strong> ورود و خروج </strong>
                                </CCardHeader>
                                <CCardBody>



                                    <CListGroup>
                                      <CListGroupItem  :color="index%3==0 ? 'light' : (index%3==1 ? 'success': 'info')" v-for="(item, index) in productInfo.logs" v-bind:key="item.input_date" >
                                        <CRow>
                                          <CCol sm="6">
                                            تاریخ و زمان ورود:
                                            {{ convertDateToJDate(item.input_date) }}
                                            <br />
                                            شناسه فاکتور خرید:
                                            <a @click="goToBlankRoute('/report/billoverallreport/' + item.input_bill_id)">{{ item.input_bill_id }}</a>

                                            <br />
                                            شناسه اقلام ورودی:
                                            {{ item.input_id }}
                                            <CInput
                                                label="شناسه اقلام ورودی جدید"
                                                v-model="editBarcode.list[index].input_id"
                                                v-if="editBarcode.enable"
                                                class="editbox"
                                            />
                                            <br />
                                            دسته بندی اقلام ورودی:
                                            {{ item.input_category_name }}
                                            <br />
                                            توضیحات اقلام ورودی:
                                            {{ item.input_description }}
                                            <br />                                            
                                            قیمت اقلام ورودی:
                                            {{ item.input_unit_price | currency(' ریال', 0, { symbolOnLeft: false }) }}
                                          </CCol>
                                          <CCol sm="6">
                                            تاریخ و زمان خروج:
                                            {{ convertDateToJDate(item.output_date) }}
                                            <br />
                                            شناسه فاکتور فروش:
                                            <a @click="goToBlankRoute('/report/invoiceoverallreport/' + item.output_invoice_id)">{{ item.output_invoice_id }}</a>

                                            <br />
                                            شناسه اقلام خروجی:
                                            {{ item.output_id }}
                                            <CInput
                                                label="شناسه اقلام خروجی جدید"
                                                v-model="editBarcode.list[index].output_id"
                                                v-if="editBarcode.enable"
                                                class="editbox"
                                            />
                                            <br />
                                            دسته بندی اقلام خروجی:
                                            {{ item.output_category_name }}
                                            <br />
                                            قیمت اقلام خروجی:
                                            {{ item.output_unit_price | currency(' ریال', 0, { symbolOnLeft: false }) }}
                                          </CCol>

                                        </CRow>
                                      </CListGroupItem>
                                    </CListGroup>




                                </CCardBody>
                            </CCard>
                        </CCollapse>


                    </CCol>
                </CRow>
                <CRow>
                    <CCol md="12">
                        <CCollapse :show="collapseBraCodeInfo" :duration="400">
                            <CCard>
                                <CCardHeader>
                                    <strong> محل در انبار </strong>
                                </CCardHeader>
                                <CCardBody>
                                    <CRow>
                                        <CCol sm="3">
                                            <CInput
                                                    label="شماره انبار"
                                                    type="number"
                                                    v-model="productInfo.location.inventory_code"
                                            />
                                        </CCol>
                                        <CCol sm="3">
                                            <CInput
                                                    label="شماره طبقه"
                                                    type="number"
                                                    v-model="productInfo.location.floor_code"
                                            />
                                        </CCol>
                                        <CCol sm="3">
                                            <CInput
                                                    label="شماره قفسه"
                                                    type="number"
                                                    v-model="productInfo.location.shelf_code"
                                            />
                                        </CCol>
                                    </CRow>
                                </CCardBody>
                                <CCardFooter class="text-left">
                                    <CButton color="success" class="text-white" @click="confirmDialog=true">
                                        <CIcon name="cil-check-circle"/>
                                        ثبت یا تغییر محل انبار
                                    </CButton>
                                </CCardFooter>
                            </CCard>
                        </CCollapse>
                    </CCol>
                </CRow>

                <CRow>
                    <CCol md="12">
                        <CCollapse :show="collapseBraCodeInfo" :duration="400">
                            <CCard>
                                <CCardHeader>
                                    <strong>تاریخچه</strong>
                                </CCardHeader>
                                <CCardBody>
                                        <v-data-table
                                                :headers="logsHeaders"
                                                :items="selectedItemLogs"
                                                sort-by="log_id"
                                                :hide-default-footer="true"
                                                :disable-pagination="true"
                                                class="elevation-1">
                                            <template v-slot:item="{item}">
                                                <tr>
                                                    <td>{{ item.log_id }}</td>
                                                    <td>{{ item.action }}</td>
                                                    <td>{{ item.user_fullname }}</td>
                                                    <td>{{ convertDateToJDate(item.set_date) }}</td>
                                                </tr>
                                            </template>
                                        </v-data-table>


                                </CCardBody>
                            </CCard>
                        </CCollapse>
                    </CCol>
                </CRow>
                <div class="edit-save-box" v-if="editBarcode.enable">
                  <CButton color="info" class="text-white mb-2 ml-2" @click="saveEditBarcode()">
                    ذخیره
                  </CButton>
                  <CButton color="danger" class="text-white mb-2 ml-2" @click="editBarcode.enable = false">
                    انصراف
                  </CButton>
                </div>
            </CCardBody>
        </CCard>
    </div>
</template>

<script>
    import {
        functionAction,
        getCategoryType,
        getProductByBarCode,
        callWebservice,
        getFunction
    } from '../../webservice/webservice';
    import {iconsSet} from '../../assets/icons/icons';
    import moment from "moment-jalaali";

    export default {
        name: 'BarCodeReader',
        props: {},
        iconsSet,
        methods: {
          goToBlankRoute(routeName) {
            let routeData = this.$base_url + routeName;
            window.open(routeData, '_blank');
          },
          getObjectNameById(list, key, id, extraKey) {
                for (let i = 0; i < list.length; i++) {
                    if (list[i][key] === id) {
                        if (extraKey) {
                            return list[i].name + ' ' + list[i][extraKey]
                        }
                        return list[i].name
                    }
                }
            },
            convertDateToJDate(dt) {
                if (dt === null) {
                    return 'نامشخص'
                }
                let convertedDate = moment(dt, 'YYYY-MM-DD HH:mm:ss').format('jYYYY/jM/jD HH:mm:ss');
                if (convertedDate === 'Invalid date') {
                    return 'نامعلوم'
                }
                return convertedDate
            },
            barCodeSearch() {
                this.collapseBraCodeInfo = false;
                getProductByBarCode(this.$http, this.barCodeText).then((resp) => {
                    this.productInfo = resp;
                    this.collapseBraCodeInfo = true;

                    getFunction(this.$http, 'logs', 0, 1000, 'name', 'desc', {
                        "code": "barcode",
                        "code_id": this.barCodeText
                    }).then((resp) => {
                        this.selectedItemLogs = resp.list
                    })  

                }, (resp) => {
                    this.$toasted.show(resp.body.message, {
                        theme: "toasted-primary",
                        position: "bottom-center",
                        duration: 3000
                    });
                })
            },
            isNumber: function (evt) {
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode < 48 || charCode > 57)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            changeProductInventoryInfo() {
                let action = 'update';
                if (this.productInfo.location.location_id === '') {
                    action = 'add'
                }
                functionAction(this.$http, 'productlocations', action, this.productInfo.location).then((resp) => {
                    this.$toasted.show(resp.message, {
                        theme: "toasted-primary",
                        position: "bottom-center",
                        duration: 3000
                    });
                    this.barCodeSearch();
                    this.confirmDialog = false;
                });
            },removeBarcode(){
                
                var r = confirm("آیا از حذف این بارکد مطمین هستید؟");
                if (r == true) {
                    const req = {
                        "barcode": this.barCodeText
                    };                    
                    callWebservice(this.$http, 'barcodes/removebarcode', req).then((resp) => {
                        this.$toasted.show(resp.message, {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 3000
                        });
                        this.barCodeSearch();
                    }, (err) => {
                      this.errors = err.body.errors;
                      this.$toasted.show(err.body.message, {
                        theme: "toasted-primary",
                        position: "bottom-center",
                        duration: 3000
                      });
                    });
                }               
         
                    
          },enableEditBarcode(){
            this.editBarcode.enable = true;
            this.editBarcode.barcode = this.barCodeText;
            this.editBarcode.list = [];
            for(var i=0;i<this.productInfo.logs.length;i++){
              var newItem = {
                id:this.productInfo.logs[i].id,
                input_id:this.productInfo.logs[i].input_id,
                output_id:(this.productInfo.logs[i].output_id != null ? this.productInfo.logs[i].output_id : "")
              };
              this.editBarcode.list.push(newItem);
            }
          },saveEditBarcode(){
            var r = confirm("آیا از ویرایش این بارکد مطمین هستید؟");
            if (r == true) {
              callWebservice(this.$http, 'barcodes/editbarcode', this.editBarcode).then((resp) => {
                this.$toasted.show(resp.message, {
                  theme: "toasted-primary",
                  position: "bottom-center",
                  duration: 3000
                });

                this.barCodeSearch();
                this.editBarcode.enable = false;
              }, (err) => {
                this.errors = err.body.errors;
                this.$toasted.show(err.body.message, {
                  theme: "toasted-primary",
                  position: "bottom-center",
                  duration: 3000
                });
              });
            }
          },replaceBarcode(){
              //alert(this.barCodeText);
              var replaced_barcode = prompt("لطفا بارکد جدید را برای جایگزینی با بارکد " + this.barCodeText + "وارد کنید. ", "");

              if (replaced_barcode != null && replaced_barcode != "") {
                const req = {
                  "barcode": this.barCodeText,
                  "barcode_replace": replaced_barcode
                };
                callWebservice(this.$http, 'barcodes/replacebarcode', req).then((resp) => {
                  this.$toasted.show(resp.message, {
                    theme: "toasted-primary",
                    position: "bottom-center",
                    duration: 3000
                  });
                  //this.barCodeSearch();
                }, (err) => {
                  this.errors = err.body.errors;
                  this.$toasted.show(err.body.message, {
                    theme: "toasted-primary",
                    position: "bottom-center",
                    duration: 3000
                  });
                });
              }else{
                alert("بارکد وارد شده معتبر نمی باشد.");
              }
          }

        },
        data: () => {
            return {
                inputOutputTableHeaders: [
                    {text: 'تاریخ و زمان ورود', value: 'input_date'},
                    {text: 'شناسه فاکتور خرید', value: 'input_bill_id'},
                    {text: 'شناسه اقلام ورودی', value: 'input_id'},
                    {text: 'تاریخ و زمان خروج', value: 'output_date'},
                    {text: 'شناسه فاکتور فروش', value: 'output_invoice_id'},
                    {text: 'شناسه اقلام خروجی', value: 'output_id'},
                ],
                logsHeaders: [
                    {text: 'شناسه', value: 'log_id'},
                    {text: 'عملیات', value: 'action'},
                    {text: 'کاربر', value: 'user_fullname'},
                    {text: 'زمان', value: 'set_date'}
                ],                 
                productCategories: [],
                barCodeText: '',
                productInfo: {
                    product: {},
                    location: {
                        inventory_code: '',
                        floor_code: '',
                        shelf_code: ''
                    }
                },
                collapseBraCodeInfo: false,
                confirmDialog: false,
                editBarcode: {
                  enable: false,
                  barcode: "",
                  product_option_id: "",
                  list: []
                },
                selectedItemLogs: []
            }
        },
        mounted() {
            if (this.$route.params.id) {
                this.barCodeText = this.$route.params.id;
                this.barCodeSearch();
            }
            getCategoryType(this.$http, 11).then((resp) => {
                this.productCategories = resp.list;
            });
        },
        computed: {
            keymap() {
                return {
                    'enter': {
                        keyup: this.barCodeSearch
                    }
                }
            }
        }
    }
</script>
<style scoped>
  .editbox {
    width: 200px;border:1px dashed red;padding:10px;border-radius: 5px;
  }
  .edit-save-box {
    position: fixed;
    top: 60px;
    left: 30px;
    border: 1px dashed red;
    padding: 20px;
    border-radius: 5px;
    background: #F7F7F7;
  }
</style>